import {
  DatabaseOutlined,
  RetweetOutlined,
  CreditCardOutlined,
  AppstoreOutlined,
  CarOutlined,
} from "@ant-design/icons";
import { ADMIN_PREFIX_PATH } from "configs/AppConfig";

const dashBoardNavTree = [
  {
    key: "dashboard-vendor",
    path: `${ADMIN_PREFIX_PATH}/dashboard-vendor`,
    title: "Dashboard",
    icon: AppstoreOutlined,
    // permissions: ['CREATE_DEALERS', 'GET_DEALERS'],
    breadcrumb: false,
    submenu: [],
  },
  {
    key: "pengiriman-produk-vendor",
    path: `${ADMIN_PREFIX_PATH}/pengiriman-produk-vendor`,
    title: "Pengiriman Produk",
    icon: CarOutlined,
    // permissions: ['CREATE_DEALERS', 'GET_DEALERS'],
    breadcrumb: false,
    submenu: [],
  },
  {
    key: "laporan-penjualan-vendor",
    path: `${ADMIN_PREFIX_PATH}/laporan-penjualan-vendor`,
    title: "Laporan Penjualan",
    icon: RetweetOutlined,
    // permissions: ['CREATE_DEALERS', 'GET_DEALERS'],
    breadcrumb: false,
    submenu: [],
  },
  {
    key: "pencairan-dana-vendor",
    path: `${ADMIN_PREFIX_PATH}/pencairan-dana-vendor`,
    title: "Pencairan Dana",
    icon: CreditCardOutlined,
    // permissions: ['CREATE_DEALERS', 'GET_DEALERS'],
    breadcrumb: false,
    submenu: [],
  },
  {
    key: "data-produk-vendor",
    path: `${ADMIN_PREFIX_PATH}/data-produk-vendor`,
    title: "Data Produk",
    icon: DatabaseOutlined,
    // permissions: ['CREATE_DEALERS', 'GET_DEALERS'],
    breadcrumb: false,
    submenu: [],
  },
];


const navigationConfig = [...dashBoardNavTree];

export default navigationConfig;
